<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>Lista di Vakatura</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>Vakatura</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Spinner Section -->
<div *ngIf="isLoadingFeaturedJobs" class="text-center" style="margin: 100px;">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

<section *ngIf="!isLoadingFeaturedJobs" class="job-area pb-70">
    <div class="container">
        <div class="section-title">
            
        </div>

        <div class="sorting-menu">
            <ul>
              <li class="filter" (click)="filterJobs('all')">All</li>
                <li *ngFor="let org of organizations" class="filter" [attr.data-filter]="org.id" (click)="filterJobs(org.id)" style="margin-bottom: 10px;">{{ org.name }}</li>

            </ul>
          </div>

          <div class="row">
            <div *ngFor="let job of jobs" class="col-lg-6 mix" [class]="job.organizationCode">
                <div class="job-item">
                     

                    <div class="job-inner align-items-center">
                        <div class="job-inner-left">
                            <h3>{{ job.title }}</h3>

                            <a *ngIf="job.suborg">{{ job.companyName }} - {{job.suborg}}</a>
                            <a *ngIf="!job.suborg">{{ job.companyName }}</a>
                            <ul>
                                <li><i class="icofont-money-bag"></i>{{ job.salary }}</li>
                                <li><i class="icofont-book"></i>{{ job.qualification }}</li>
                            </ul>
                        </div>
        
                        <div class="job-inner-right">
                            <div class="d-lg-block mb-2">
                                <img [src]="job.logo" alt="Job" class="job-details-logo">
                            </div>
                          
                        </div>
                    </div>
                    <button type="button" class="btn btn-primary btn-lg sign-up-btn mt-4" style="background:#061f35; width:100%; border-radius: 0;" [routerLink]="['/job-details', job.id]">Mas Informashon</button>
                </div>
            </div>
          </div>
        </div>

    
</section>
